export function useProductMetrics(productId: string) {
  const productMetricsStore = useProductMetricsStore()
  return productMetricsStore.getMetricsForProduct(productId)
}
